import request from '../request'

export default {
  getTitulosProfesionales() {
    return request.get('titulo_profesional')
  }
}
